import { Handle, Position, type Node, type NodeProps } from '@xyflow/react';
import { CircleStop } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { WorkflowNodeData } from '../types';

type EndNodeProps = NodeProps<Node<WorkflowNodeData, 'end'>>;

export function EndNode({ data, selected }: EndNodeProps) {
  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        className="!w-2.5 !h-2.5 !border-2 !bg-background !border-rose-500"
      />
      <div
        className={cn(
          'min-w-[160px] rounded-lg border-2 bg-card px-3 py-2.5 shadow-sm transition-shadow',
          'border-rose-500/60 bg-rose-500/5',
          selected && 'ring-2 ring-rose-500 ring-offset-2 shadow-md'
        )}
      >
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-rose-500/20 text-rose-600 dark:text-rose-400">
            <CircleStop className="h-4 w-4" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-foreground">End</p>
            <p className="truncate text-xs text-muted-foreground">{data.label}</p>
          </div>
        </div>
      </div>
    </>
  );
}
